import { useState, useEffect } from 'react';

export const useHeaderHeight = (): number => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const header = document.querySelector('[data-id="main-header"]');
    if (!header) return;

    const updateHeight = () => {
      setHeight(header.getBoundingClientRect().height);
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  return height;
};
